module.exports = __webpack_public_path__ + "img/horizontal_shine.511cdc5e.png";